/**
 * Processing screen for workflow legal ID — matches IVA ProcessingScreen design.
 * Shows spinner with hide/show toggle.
 */

import { useTranslation } from "react-i18next";
import styles from "../legalIdVerification/LegalIdVerification.module.scss";

interface Props {
  showSpinner: boolean;
  onHideAnimation: () => void;
}

export function WorkflowProcessingScreen({ showSpinner, onHideAnimation }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      <h2 className={styles.processingTitle}>{t('legalId.processing.title')}</h2>

      {showSpinner && <div className={styles.processingSpinner} />}

      <button
        className={styles.hideAnimationLink}
        onClick={onHideAnimation}
      >
        {showSpinner ? t('legalId.processing.hideAnimation') : t('legalId.processing.showAnimation')}
      </button>
    </div>
  );
}
